import { atom } from "jotai";

interface WindowSize {
  width: number;
  height: number;
  scale: number;
}

export const windowSizeAtom = atom<WindowSize>({ width: 0, height: 0, scale: 1 });
export const uaParserAtom: any = atom(null);
export const fromDataAtom: any = atom({

  // sectionTitle: '農家様お問い合わせフォーム',
  // data: {
  //   subject: "その他",
  //   name: "金沢　徹",
  //   company_name: "株式会社グラウンド",
  //   position: "代表取締役",
  //   website: "ground-inc.jp",
  //   email: "t.kanazawa@ground-inc.jp",
  //   email_confirm: "t.kanazawa@ground-inc.jp",
  //   tel: "0000000000",
  //   address: "中央区新富1-7-8 イタクラビル8F",
  //   cultivation_area: "約900平方メートル",
  //   farming_method_1:"慣行農業",
  //   farming_method_6:"その他",
  //   cultivated_crops: "野菜",
  //   message: "ああ",
  // },

});
